/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Full Screen Exit Icon component.
 */
export const MaterialFullScreenExitIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19541)'>
        <path d='M1 18.5H5.5V23H8.5V15.5H1V18.5ZM5.5 6.5H1V9.5H8.5V2H5.5V6.5ZM14.5 23H17.5V18.5H22V15.5H14.5V23ZM17.5 6.5V2H14.5V9.5H22V6.5H17.5Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_19541'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaterialFullScreenExitIcon;
